import { ShoppingBag } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useFarmCart } from '@/context/FarmCartContext';
import { useIsMobile } from '@/hooks/use-mobile';
import { formatPrice } from '@/lib/formatMoney';

/**
 * Sticky bottom cart bar for mobile.
 * Only visible on mobile when cart has items.
 */
export function MobileCartBar() {
  const isMobile = useIsMobile();
  const { itemCount, totalPrice, cart, openCart } = useFarmCart();

  // Only show on mobile with items
  if (!isMobile || itemCount === 0 || !cart) {
    return null;
  }

  const currencyCode = cart.items[0]?.product.currencyCode || 'SEK';
  const itemText = itemCount === 1 ? 'vara' : 'varor';

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-t border-border shadow-lg pb-safe">
      <div className="container py-3">
        <div className="flex items-center justify-between gap-4">
          {/* Summary */}
          <div className="flex items-center gap-3">
            <div className="relative">
              <ShoppingBag className="h-5 w-5 text-muted-foreground" />
              <span className="absolute -top-1 -right-1 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-primary text-[9px] font-semibold text-primary-foreground">
                {itemCount > 9 ? '9+' : itemCount}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="text-sm font-medium text-foreground">
                {itemCount} {itemText} • {formatPrice(totalPrice, currencyCode)}
              </span>
              <span className="text-xs text-muted-foreground">
                från {cart.producerName}
              </span>
            </div>
          </div>

          {/* CTA */}
          <Button 
            size="sm" 
            className="gap-2 shrink-0"
            onClick={openCart}
          >
            Till varukorgen
          </Button>
        </div>
      </div>
    </div>
  );
}
